export default {
  allDeliveryMethods(state) {
    return state.logisticProviders
      .map(logisticProvider => Object.assign({}, logisticProvider, {
        delivery_methods: logisticProvider.delivery_methods.map(dm => Object.assign({}, dm, {
          logistic_provider_id: logisticProvider.id,
          logistic_provider_name: logisticProvider.name,
        })),
      }))
      .reduce((itemA, itemB) => ([
        ...itemA,
        ...itemB.delivery_methods,
      ]), [])
      .map(dm => Object.assign({}, dm, {
        enabled: String(dm.enabled),
      }));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-remove/store/getters.js